import { SettingIcon } from "@100mslive/react-icons";
import {
    HMSRoomState,
    selectIsLocalAudioEnabled,
    selectIsLocalVideoEnabled,
    selectLocalPeer,
    selectLocalPeerID,
    selectRoomState,
    useAVToggle,
    useHMSActions,
    useHMSStore,
    usePreviewJoin,
} from "@100mslive/react-sdk";
import {
    Flex,
    IconButton,
    Loading,
    styled,
    StyledVideoTile,
    useBorderAudioLevel,
    useTheme,
    Video,
} from "@100mslive/react-ui";
import { Avatar, Box, Button } from "@material-ui/core";
import moment from "moment";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { NavLink, Outlet } from "react-router-dom";
import Swal from "sweetalert2";
import toastr from "toastr";
import _ from "underscore";
import SharePop from "../../../components/common/shareLivestream";
import Modal from "../../../components/Modal/Modal";
import { socket, startSocketService } from "../../../helpers/socketHelper";
import { IsNullOrEmpty, sleep, slugify } from "../../../helpers/utility";
import { uploadLivesRequest } from "../../../store/file/file.actions";
import { getUploadedLiveImage } from "../../../store/file/file.selector";
import {
    getCategoryRequest,
    getProductByIDSRequest,
} from "../../../store/shopping/shopping.actions";
import {
    getCartList,
    getCartProductList,
    getCategoryList,
} from "../../../store/shopping/shopping.selector";
import {
    createBookMarkRequest,
    createWowzaEventRequest,
    fetchEventRequest,
    fetchLiveStreamByIdRequest,
    fetchLiveStreamByIdSuccess,
    updateLiveStreamingRequest,
} from "../../../store/social/social.actions";
import SocialAPI from "../../../store/social/social.api";
import {
    getLiveStream,
    getReactions,
} from "../../../store/social/social.selector";
import {
    createRoomRequest,
    fetchAppTokenRequest,
} from "../../../store/social/streaming/streaming.actions";
import {
    GetAppToken,
    GetRoomDetails,
} from "../../../store/social/streaming/streaming.selector";
import { searchUserRequest } from "../../../store/user/user.actions";
import {
    getImage,
    getSearchedUsers,
    getUserProfile,
} from "../../../store/user/user.selector";
import VIPCircleAPI from "../../../store/user/vipcircle/vipcircle.api";
import { getCurrentVIPCircle } from "../../../store/user/vipcircle/vipcircle.selector";
import { ConnectionIndicator } from "./preview/ConnectionIndicator";
import Settings from "./preview/Settings";
import {
    UserPreferencesKeys,
    useUserPreferences,
} from "./preview/useUserPreferences";

const defaultPreviewPreference = {
    name: "",
    isAudioMuted: false,
    isVideoMuted: false,
};

const settingStyles = {
    bottom: "10px",
    right: "20px",
};

const Preview = ({
    token,
    onJoin,
    env,
    skipPreview,
    onChangeFullScreen,
    initialName,
    livestream,
    userProfile,
}) => {
    const dispatch = useDispatch();
    const history = useNavigate();
    const hmsActions = useHMSActions();
    const localPeer = useHMSStore(selectLocalPeerID);
    const roomState = useHMSStore(selectRoomState);
    const [isFullScreen, setFullScreen] = useState(false);
    const [show, setShow] = useState(false);
    const audioEnabled = useHMSStore(selectIsLocalAudioEnabled);
    const videoEnabled = useHMSStore(selectIsLocalVideoEnabled);
    const [previewPreference, setPreviewPreference] = useUserPreferences(
        UserPreferencesKeys.PREVIEW,
        defaultPreviewPreference
    );

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleAudioMute = async () => {
        await hmsActions.setLocalAudioEnabled(!audioEnabled);
    };

    const handleVideoMute = async () => {
        await hmsActions.setLocalVideoEnabled(!videoEnabled);
    };

    useEffect(() => {
        onChangeFullScreen(isFullScreen);
    }, [isFullScreen]);
    const [name, setName] = useState(initialName || previewPreference.name);
    const { isLocalAudioEnabled, isLocalVideoEnabled } = useAVToggle();
    const [showShared, setShared] = useState(false);

    const { enableJoin, preview, join } = usePreviewJoin({
        name,
        token,
        initEndpoint: env ? `https://${env}-init.100ms.live/init` : undefined,
        initialSettings: {
            isAudioMuted: skipPreview ? true : previewPreference.isAudioMuted,
            isVideoMuted: skipPreview ? true : previewPreference.isVideoMuted,
        },
        captureNetworkQualityInPreview: true,
    });

    const savePreferenceAndJoin = useCallback(() => {
        setPreviewPreference({
            name,
            isAudioMuted: !isLocalAudioEnabled,
            isVideoMuted: !isLocalVideoEnabled,
        });
        join();
        onJoin && onJoin();
    }, [
        join,
        isLocalAudioEnabled,
        isLocalVideoEnabled,
        name,
        setPreviewPreference,
        onJoin,
    ]);
    useEffect(() => {
        if (token && roomState === HMSRoomState.Disconnected) {
            if (skipPreview) {
                savePreferenceAndJoin();
            } else if (!localPeer) {
                preview();
            }
        }
        navigator.mediaDevices
            .getUserMedia({
                audio: true,
                video: true,
            })
            .then((stream) => {
                window.localStream = stream;
            })
            .catch((err) => {
                console.log(err);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, localPeer, roomState, skipPreview]);
    const shareUrl =
        process.env.REACT_APP_URL + "/video/" + livestream._id;
    const title = livestream.title;
    return (
        <Container className="m-0 p-0 relative">
            <PreviewTile name={name} userProfile={userProfile} />
            <div className="flex justify-between items-center w-full">
                <Button
                    variant="contained"
                    className="end-live-btn btn bg-danger text-white"
                    onClick={() => {
                        history(-1);
                    }}
                >
                    Cancel
                </Button>
                <Flex
                    as="form"
                    align="center"
                    className="my-2"
                    onSubmit={(e) => {
                        e.preventDefault();
                        savePreferenceAndJoin();
                    }}
                >
                    <div className="flex mx-2 items-center text-black-60 hover:text-orange-color cursor-pointer">
                        <span>
                            <svg
                                width="21"
                                onClick={() => setFullScreen(!isFullScreen)}
                                height="21"
                                viewBox="0 0 21 21"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M1.5 6V1.5M1.5 1.5H6M1.5 1.5L7.125 7.125M19.5 6V1.5M19.5 1.5H15M19.5 1.5L13.875 7.125M1.5 15V19.5M1.5 19.5H6M1.5 19.5L7.125 13.875M19.5 19.5L13.875 13.875M19.5 19.5V15M19.5 19.5H15"
                                    stroke="black"
                                    stroke-opacity="0.3"
                                    stroke-width="1.6875"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </span>
                    </div>

                    <div className="flex  mx-2 items-center text-black-60 hover:text-orange-color cursor-pointer">
                        <span>
                            <svg
                                width="23"
                                onClick={() => handleVideoMute()}
                                opacity={!videoEnabled ? 0.5 : 1}
                                height="17"
                                viewBox="0 0 23 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M14.75 6.25L19.8719 3.68906C20.6199 3.31505 21.5 3.85898 21.5 4.69529V12.3047C21.5 13.141 20.6199 13.6849 19.8719 13.3109L14.75 10.75M3.5 15.25H12.5C13.7426 15.25 14.75 14.2426 14.75 13V4C14.75 2.75736 13.7426 1.75 12.5 1.75H3.5C2.25736 1.75 1.25 2.75736 1.25 4V13C1.25 14.2426 2.25736 15.25 3.5 15.25Z"
                                    stroke="#7900F8"
                                    stroke-width="1.6875"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </span>
                    </div>
                    <div className="flex  mx-2 items-center text-black-60 hover:text-orange-color cursor-pointer">
                        <span>
                            <svg
                                onClick={() => handleAudioMute()}
                                opacity={!audioEnabled ? 0.5 : 1}
                                width="18"
                                height="25"
                                viewBox="0 0 18 25"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M17.125 11.375C17.125 15.7242 13.5992 19.25 9.25 19.25M9.25 19.25C4.90076 19.25 1.375 15.7242 1.375 11.375M9.25 19.25V23.75M9.25 23.75H4.75M9.25 23.75H13.75M9.25 14.75C7.38604 14.75 5.875 13.239 5.875 11.375V4.625C5.875 2.76104 7.38604 1.25 9.25 1.25C11.114 1.25 12.625 2.76104 12.625 4.625V11.375C12.625 13.239 11.114 14.75 9.25 14.75Z"
                                    stroke="#7900F8"
                                    stroke-width="1.6875"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </span>
                    </div>
                    {livestream.owner._id === userProfile._id ? (
                        <Button
                            className="mx-1 go-live"
                            type="button"
                            color="secondary"
                            variant="contained"
                            onClick={() => {
                                savePreferenceAndJoin();
                                SocialAPI.sendStartLiveNotification(
                                    livestream._id
                                );
                            }}
                            disabled={!enableJoin}
                        >
                            Go Live
                        </Button>
                    ) : (
                        <></>
                    )}
                    <div className="flex items-center text-black-60 hover:text-orange-color cursor-pointer">
                        <span>
                            <svg
                                width="22"
                                height="20"
                                viewBox="0 0 22 20"
                                className="stroke-current  mr-1.5 md:mr-2.5"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M10.049 1.92664C10.3483 1.00537 11.6517 1.00538 11.951 1.92664L13.4699 6.60055C13.6038 7.01254 13.9877 7.29148 14.4209 7.29149L19.3354 7.29168C20.3041 7.29172 20.7068 8.53127 19.9232 9.10067L15.9474 11.9895C15.5969 12.2441 15.4503 12.6955 15.5841 13.1075L17.1026 17.7815C17.4019 18.7028 16.3475 19.4689 15.5638 18.8995L11.5878 16.011C11.2373 15.7564 10.7627 15.7564 10.4122 16.011L6.43622 18.8995C5.65252 19.4689 4.5981 18.7028 4.8974 17.7815L6.41589 13.1075C6.54974 12.6955 6.40309 12.2441 6.05263 11.9895L2.07683 9.10067C1.29317 8.53127 1.69592 7.29172 2.66461 7.29168L7.57911 7.29149C8.01231 7.29148 8.39623 7.01254 8.53011 6.60055L10.049 1.92664Z"
                                    stroke="black"
                                    stroke-opacity="0.3"
                                    strokeWidth="1.5"
                                />
                            </svg>
                        </span>
                        <button
                            disabled={livestream.isBookmark}
                            onClick={() => {
                                dispatch(
                                    createBookMarkRequest({
                                        livestream: livestream._id,
                                    })
                                );
                            }}
                            className="text-sm font-medium capitalize"
                        ></button>
                    </div>
                    <div className="flex items-center text-black-60 hover:text-orange-color cursor-pointer">
                        <span>
                            <svg
                                onClick={() => setShared(true)}
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                className="stroke-current  mr-1.5 md:mr-2.5"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M6.68387 11.3419C6.88616 10.9381 7 10.4824 7 10C7 9.51763 6.88616 9.06185 6.68387 8.65807M6.68387 11.3419C6.19134 12.3251 5.17449 13 4 13C2.34315 13 1 11.6569 1 10C1 8.34315 2.34315 7 4 7C5.17449 7 6.19134 7.67492 6.68387 8.65807M6.68387 11.3419L13.3161 14.6581M6.68387 8.65807L13.3161 5.34193M13.3161 5.34193C13.8087 6.32508 14.8255 7 16 7C17.6569 7 19 5.65685 19 4C19 2.34315 17.6569 1 16 1C14.3431 1 13 2.34315 13 4C13 4.48237 13.1138 4.93815 13.3161 5.34193ZM13.3161 14.6581C13.1138 15.0619 13 15.5176 13 16C13 17.6569 14.3431 19 16 19C17.6569 19 19 17.6569 19 16C19 14.3431 17.6569 13 16 13C14.8255 13 13.8087 13.6749 13.3161 14.6581Z"
                                    stroke="black"
                                    stroke-opacity="0.3"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </span>
                    </div>

                    <div className="flex items-center text-black-60 hover:text-orange-color cursor-pointer">
                        <span>
                            <svg
                                onClick={() =>
                                    history("/page/preview/audience")
                                }
                                width="25"
                                height="22"
                                viewBox="0 0 25 22"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M19.4986 18.06C20.9237 18.1765 22.3574 17.9929 23.7072 17.5211C23.7588 16.8859 23.6294 16.2491 23.3341 15.6844C23.0388 15.1197 22.5897 14.6501 22.0387 14.33C21.4876 14.0099 20.8572 13.8523 20.2204 13.8755C19.5835 13.8987 18.9663 14.1017 18.44 14.4611M19.4975 18.0589L19.4986 18.0938C19.4986 18.3469 19.4851 18.5966 19.457 18.843C17.4155 20.0143 15.1022 20.6288 12.7486 20.625C10.3074 20.625 8.01574 19.977 6.04024 18.843C6.01131 18.5826 5.99741 18.3208 5.99861 18.0589M19.4986 18.0589C19.4942 16.7838 19.1271 15.5364 18.44 14.4623M18.44 14.4623C17.8301 13.5058 16.9889 12.7185 15.994 12.1734C14.9992 11.6283 13.883 11.343 12.7486 11.3438C11.6144 11.3432 10.4984 11.6286 9.50381 12.1737C8.5092 12.7188 7.66811 13.5059 7.05836 14.4623M7.05836 14.4623C6.5321 14.1032 5.91496 13.9004 5.27829 13.8774C4.64163 13.8544 4.01145 14.012 3.46061 14.3321C2.90978 14.6521 2.46078 15.1216 2.16554 15.6861C1.8703 16.2507 1.74088 16.8872 1.79223 17.5223C3.14101 17.9967 4.57507 18.1795 5.99973 18.0589M7.05724 14.4623C6.37056 15.5365 6.00378 16.7839 5.99973 18.0589M16.1236 4.59375C16.1236 5.48886 15.768 6.3473 15.1351 6.98024C14.5022 7.61317 13.6437 7.96875 12.7486 7.96875C11.8535 7.96875 10.9951 7.61317 10.3621 6.98024C9.72919 6.3473 9.37361 5.48886 9.37361 4.59375C9.37361 3.69864 9.72919 2.8402 10.3621 2.20726C10.9951 1.57433 11.8535 1.21875 12.7486 1.21875C13.6437 1.21875 14.5022 1.57433 15.1351 2.20726C15.768 2.8402 16.1236 3.69864 16.1236 4.59375V4.59375ZM22.8736 7.96875C22.8736 8.30116 22.8081 8.63031 22.6809 8.93742C22.5537 9.24452 22.3673 9.52357 22.1322 9.75861C21.8972 9.99366 21.6181 10.1801 21.311 10.3073C21.0039 10.4345 20.6748 10.5 20.3424 10.5C20.01 10.5 19.6808 10.4345 19.3737 10.3073C19.0666 10.1801 18.7875 9.99366 18.5525 9.75861C18.3174 9.52357 18.131 9.24452 18.0038 8.93742C17.8766 8.63031 17.8111 8.30116 17.8111 7.96875C17.8111 7.29742 18.0778 6.65359 18.5525 6.17889C19.0272 5.70418 19.671 5.4375 20.3424 5.4375C21.0137 5.4375 21.6575 5.70418 22.1322 6.17889C22.6069 6.65359 22.8736 7.29742 22.8736 7.96875V7.96875ZM7.68611 7.96875C7.68611 8.30116 7.62064 8.63031 7.49343 8.93742C7.36622 9.24452 7.17977 9.52357 6.94472 9.75861C6.70968 9.99366 6.43063 10.1801 6.12353 10.3073C5.81642 10.4345 5.48727 10.5 5.15486 10.5C4.82245 10.5 4.4933 10.4345 4.18619 10.3073C3.87909 10.1801 3.60004 9.99366 3.365 9.75861C3.12995 9.52357 2.9435 9.24452 2.81629 8.93742C2.68908 8.63031 2.62361 8.30116 2.62361 7.96875C2.62361 7.29742 2.89029 6.65359 3.365 6.17889C3.8397 5.70418 4.48353 5.4375 5.15486 5.4375C5.82619 5.4375 6.47002 5.70418 6.94472 6.17889C7.41943 6.65359 7.68611 7.29742 7.68611 7.96875V7.96875Z"
                                    stroke="black"
                                    stroke-opacity="0.3"
                                    stroke-width="1.6875"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </span>
                    </div>
                </Flex>
                <Button style={{ visibility: "hidden" }}></Button>
            </div>
            <Modal show={showShared} onClose={() => setShared(false)}>
                <SharePop
                    onClose={() => setShared(false)}
                    shareUrl={shareUrl}
                    title={livestream.owner.fullName}
                    subTitle={"@" + livestream.owner.userName}
                    image={getImage(livestream.owner.attachments)}
                    heading="Share"
                />
            </Modal>
        </Container>
    );
};

const PreviewTile = ({ userProfile }) => {
    const videoRef = useRef(null);
    const localPeer = useHMSStore(selectLocalPeer);
    const borderAudioRef = useBorderAudioLevel(localPeer?.audioTrack);
    const isVideoOn = useHMSStore(selectIsLocalVideoEnabled);
    const hmsActions = useHMSActions();
    const {
        aspectRatio: { width, height },
    } = useTheme();

    useEffect(() => {
        navigator.permissions.query({ name: "camera" }).then(function (result) {
            if (result.state === "granted") {
                //permission has already been granted, no prompt is shown
            } else if (result.state === "prompt") {
                //there's no peristent permission registered, will be showing the prompt
            } else if (result.state === "denied") {
                Swal.fire({
                    title: "Permission Required",
                    text: "You dont have permission to access camera and microphone from this device.",
                    icon: "error",
                    showCancelButton: false,
                    confirmButtonColor: "red",
                    confirmButtonText: "Close",
                    customClass: {
                        cancelButton: "order-1 right-gap",
                        confirmButton: "order-2",
                        denyButton: "order-3",
                    },
                });
            }
        });
        return () => {
            hmsActions.leave();
        };
    }, []);

    return (
        <StyledVideoTile.Container
            css={{
                aspectRatio: "auto",
                width: "100%",
                height: "min(55vw, calc(100vh - 200px))",
                "@sm": {
                    width: "100%",
                    height: "min(58vh, 76vh)",
                    maxWidth: "98%",
                },
            }}
            ref={borderAudioRef}
        >
            {localPeer ? (
                <>
                    <ConnectionIndicator isTile peerId={localPeer.id} />
                    <span
                        className="streamingStatus text-sm"
                        style={{ top: 0 }}
                    >
                        PREVIEW
                    </span>
                    {!isVideoOn ? (
                        <Box
                            display="flex"
                            flexDirection="column"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Avatar
                                style={{ width: 150, height: 150 }}
                                src={getImage(userProfile.avatar.attachments)}
                                alt={userProfile.fullName}
                            />
                            <span className="text-bold-center">
                                {" "}
                                {userProfile.fullName}
                            </span>
                        </Box>
                    ) : (
                        <Video
                            mirror={true}
                            ref={videoRef}
                            trackId={localPeer.videoTrack}
                            data-testid="preview_tile"
                        />
                    )}
                    <Settings>
                        <StyledVideoTile.AttributeBox css={settingStyles}>
                            <IconButton data-testid="preview_setting_btn">
                                <SettingIcon />
                            </IconButton>
                        </StyledVideoTile.AttributeBox>
                    </Settings>
                </>
            ) : (
                <Loading size={100} />
            )}
        </StyledVideoTile.Container>
    );
};

const Container = styled("div", {
    borderRadius: "$2",
    backgroundColor: "$previewBg",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "2rem 6rem",
    "@md": {
        borderRadius: "0",
        padding: "0",
        width: "100%",
        height: "100%",
    },
});

const PreviewLive = () => {
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [hashTags, setHashTags] = useState([]);
    const [shareModal, setShareModal] = useState(false);
    const [selectedMenu, setSelectedMenu] = useState("Info");
    const [bannerImageSrc, setBannerImageSrc] = useState("");
    const [isFullScreen, setFullScreen] = useState(true);
    const [form, setForm] = useState(false);
    const roomState = useHMSStore(selectRoomState);
    const [values, setValues] = useState({
        day: moment().add(30, "minutes").format("DD"),
        month: moment().add(30, "minutes").format("MM"),
        year: moment().add(30, "minutes").format("YYYY"),
        hour: moment().add(30, "minutes").format("hh"),
        minute: moment().add(30, "minutes").format("mm"),
        meridian: moment().add(30, "minutes").format("a"),
        timeZone: moment.tz.guess(),
    });
    const dispatch = useDispatch();
    const history = useNavigate();
    const hmsActions = useHMSActions();
    const localPeer = useHMSStore(selectLocalPeerID);
    const [isConnected, setConnection] = useState(false);

    function showUnAuthorized() {
        Swal.fire({
            title: "Invited only",
            text: "You do not have access to this live.",
            icon: "error",
            showCancelButton: false,
            confirmButtonColor: "red",
            confirmButtonText: "Close",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        }).then((result) => {
            if (result.isConfirmed) {
                history("/");
            }
        });
    }

    const KeyCodes = {
        comma: 188,
        enter: 13,
    };
    const delimiters = [KeyCodes.comma, KeyCodes.enter, KeyCodes.space];
    const {
        livestream,
        vipCircles,
        users,
        roomDetail,
        categories,
        token,
        liveImage,
        cartProducts,
        cart,
        userProfile,
    } = useSelector((state) => {
        return {
            livestream: getLiveStream(state),
            cartProducts: getCartProductList(state),
            cart: getCartList(state),
            userProfile: getUserProfile(state),
            users: getSearchedUsers(state),
            reactions: getReactions(state),
            categories: getCategoryList(state),
            liveImage: getUploadedLiveImage(state),
            token: GetAppToken(state),
            roomDetail: GetRoomDetails(state),
            vipCircles: getCurrentVIPCircle(state),
        };
    });

    useEffect(() => {
        if (livestream.streamingStatus === "Waiting") {
            let selectedCategory = _.find(
                categories,
                (x) => x._id === livestream.category
            );
            let invitedGuests = livestream.guestInvited;
            let emailGuests = livestream.emails;
            if (userProfile._id === livestream.owner._id) {
                handleJoin();
            } else if (selectedCategory) {
                switch (selectedCategory.name) {
                    case "Public Hall":
                        handleJoin();
                        break;
                    case "Private Hall":
                        if (livestream.isSubscribe) {
                            handleJoin();
                        } else {
                            Swal.fire({
                                title: "Subscription needed",
                                text: "Please subscribe to enjoy the livestream",
                                icon: "error",
                                showCancelButton: false,
                                confirmButtonColor: "red",
                                confirmButtonText: "Close",
                                customClass: {
                                    cancelButton: "order-1 right-gap",
                                    confirmButton: "order-2",
                                    denyButton: "order-3",
                                },
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    history("/" + livestream.owner.userName, {
                                        category: selectedCategory,
                                    });
                                }
                            });
                        }
                        break;
                    case "Meeting Room":
                        if (
                            invitedGuests.indexOf(userProfile._id) > -1 ||
                            emailGuests.indexOf(userProfile.email) > -1
                        ) {
                            handleJoin();
                        } else {
                            showUnAuthorized();
                        }
                        break;
                    case "VIP Circle":
                        if (invitedGuests.indexOf(userProfile._id) > -1) {
                            let isInVIP =
                                livestream.vipCircleDetail &&
                                livestream.vipCircleDetail.vipCircle &&
                                livestream.vipCircleDetail.vipCircle.guests.filter(
                                    (x) =>
                                        x.status === "Subscribed" &&
                                        x.userId === userProfile._id
                                );
                            if (isInVIP && isInVIP.length > 0) {
                                handleJoin();
                            } else {
                                Swal.fire({
                                    title: "Subscribe to unlock",
                                    text: "Please subscribe to the VIP circle to access the content",
                                    icon: "error",
                                    showCancelButton: false,
                                    confirmButtonColor: "red",
                                    confirmButtonText: "Close",
                                    customClass: {
                                        cancelButton: "order-1 right-gap",
                                        confirmButton: "order-2",
                                        denyButton: "order-3",
                                    },
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        history(
                                            "/" + livestream.owner.userName,
                                            {
                                                category: selectedCategory,
                                            }
                                        );
                                    }
                                });
                            }
                        } else {
                            Swal.fire({
                                title: "Subscribe to unlock",
                                text: "Please subscribe to the VIP circle to access the content",
                                icon: "error",
                                showCancelButton: false,
                                confirmButtonColor: "red",
                                confirmButtonText: "Close",
                                customClass: {
                                    cancelButton: "order-1 right-gap",
                                    confirmButton: "order-2",
                                    denyButton: "order-3",
                                },
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    history("/" + livestream.owner.userName);
                                }
                            });
                        }
                        break;
                }
            }
        }
    }, [categories, livestream]);

    function copyToClipboard() {
        /* Get the text field */
        var copyText = document.getElementById("myInput");

        /* Select the text field */
        copyText.select();
        copyText.setSelectionRange(0, 99999); /* For mobile devices */

        /* Copy the text inside the text field */
        navigator.clipboard.writeText(copyText.value);

        /* Alert the copied text */
        toastr.success("Copied the referral code", "Copied to Clipboard");
    }

    const changeBanner = async (e) => {
        const files = e.target.files[0];

        dispatch(uploadLivesRequest(files));

        const reader = new FileReader();
        reader.addEventListener(
            "load",
            function () {
                setBannerImageSrc(reader.result);
            },
            false
        );

        if (files) {
            reader.readAsDataURL(files);
        } else {
            setBannerImageSrc("");
        }
    };

    const validate = () => {
        return !IsNullOrEmpty(title) && !IsNullOrEmpty(description);
    };

    const savePreviewStream = (sch) => {
        let data = {};
        if (validate()) {
            if (!IsNullOrEmpty(title)) {
                data.title = title;
            }

            if (!IsNullOrEmpty(description)) {
                data.contents = description;
            }

            if (hashTags.length > 0) {
                data.hashtags = hashTags.map((x) => slugify(x.id));
            }

            if (liveImage && liveImage._id) {
                data.attachments = liveImage._id;
            }

            if (sch) {
                data.timeStart = moment(
                    `${values.year}-${values.month}-${values.day} ${values.hour}:${values.minute}:${values.meridian}`,
                    "YYYY-MM-DD hh:mm:a"
                )
                    .tz(values.timeZone)
                    .format();
            }

            if (sch) {
                if (
                    moment(data.timeStart).diff(
                        moment().tz(values.timeZone),
                        "minutes"
                    ) < 25
                ) {
                    Swal.fire({
                        title: "Livestream",
                        text: "Please schedule a livestream atleast 30 minutes from now",
                        icon: "error",
                        showCancelButton: true,
                        cancelButtonColor: "#d33",
                        showConfirmButton: false,
                        cancelButtonText: "Close",
                        customClass: {
                            cancelButton: "order-1 right-gap",
                            confirmButton: "order-2",
                            denyButton: "order-3",
                        },
                    });
                } else {
                    let selectedCategory = _.find(
                        categories,
                        (x) => x._id === livestream.category
                    );
                    SocialAPI.UpdatePreviewLiveStream(livestream._id, data)
                        .then(async () => {
                            let VIPEmails = [];
                            let VIPIds = [];
                            if (selectedCategory.name === "VIP Circle") {
                                let circle = await VIPCircleAPI.GetVIPCircle(
                                    livestream.parent
                                );
                                VIPEmails = circle.data.guests
                                    .filter((x) => x.status === "Subscribed")
                                    .map((x) => x.userId);
                                const filterIds = _.filter(
                                    users,
                                    (x) => VIPEmails.indexOf(x._id) > -1
                                );
                                VIPEmails = filterIds.map((x) => x.email);
                                VIPIds = filterIds.map((x) => x._id);
                            }

                            [...livestream.emails, ...VIPEmails].map((ls) => {
                                let mail = ``;
                                if (selectedCategory.name === "Public Hall") {
                                    mail = `<p style="text-align: center; color:#000; font-size: 22px; font-weight: 600;">
                Scheduled public hall has been set
                </p>
                <p style="line-height: 30px; text-align:center">
                    Hello <span style="color:#8B22F9">${ls}</span>,<br />
                    <span style="color:#8B22F9">${
                        livestream.owner.fullName
                    }</span> has scheduled a public hall.<br/>
                    Here are the public hall details
                </p>
                <p style="text-align:center;background:#F1F1F1;">
                    <br />
                    <span style="color:#8B22F9">Public Hall</span>: ${
                        livestream.title
                    }<br />
                            <span style="color:#8B22F9">Description</span>: ${
                                livestream.contents
                            }<br />
                    <span style="color:#8B22F9">Date and Time</span>: ${moment(
                        data.timeStart
                    ).format("lll")}<br />
                    <br />
                </p>`;
                                } else if (
                                    selectedCategory.name === "Private Hall"
                                ) {
                                    mail = `<p style="text-align: center; color:#000; font-size: 22px; font-weight: 600;">
                Scheduled private lounge has been set
                </p>
                <p style="line-height: 30px; text-align:center">
                    Hello <span style="color:#8B22F9">${ls}</span>,<br />
                    <span style="color:#8B22F9">${
                        livestream.owner.fullName
                    }</span> has scheduled a private lounge.<br/>
                    Here are the private lounge details
                </p>
                <p style="text-align:center;background:#F1F1F1;">
                    <br />
                    <span style="color:#8B22F9">Private Lounge</span>: ${
                        livestream.title
                    }<br />
                            <span style="color:#8B22F9">Description</span>: ${
                                livestream.contents
                            }<br />
                    <span style="color:#8B22F9">Date and Time</span>: ${moment(
                        data.timeStart
                    ).format("lll")}<br />
                    <br />
                </p>`;
                                } else if (
                                    selectedCategory.name === "Meeting Room"
                                ) {
                                    mail = `<p style="text-align: center; color:#000; font-size: 22px; font-weight: 600;">
                Scheduled meeting has been set
                </p>
                <p style="line-height: 30px; text-align:center">
                    Hello <span style="color:#8B22F9">${ls}</span>,<br />
                    <span style="color:#8B22F9">${
                        livestream.owner.fullName
                    }</span> has scheduled a video meeting.<br/>
                    Here are the meeting room details
                </p>
                <p style="text-align:center;background:#F1F1F1;">
                    <br />
                    <span style="color:#8B22F9">Meeting Room</span>: ${
                        livestream.title
                    }<br />
                            <span style="color:#8B22F9">Description</span>: ${
                                livestream.contents
                            }<br />
                    <span style="color:#8B22F9">Date and Time</span>: ${moment(
                        data.timeStart
                    ).format("lll")}<br />
                    <br />
                </p>`;
                                } else if (
                                    selectedCategory.name === "VIP Circle"
                                ) {
                                    mail = `<p style="text-align: center; color:#000; font-size: 22px; font-weight: 600;">
                Scheduled VIP circle has been set
                </p>
                <p style="line-height: 30px; text-align:center">
                    Hello <span style="color:#8B22F9">${ls}</span>,<br />
                    <span style="color:#8B22F9">${
                        livestream.owner.fullName
                    }</span> has scheduled a VIP Circle.<br/>
                    Here are the VIP Circle details
                </p>
                <p style="text-align:center;background:#F1F1F1;">
                    <br />
                    <span style="color:#8B22F9">VIP Circle</span>: ${
                        livestream.title
                    }<br />
                            <span style="color:#8B22F9">Description</span>: ${
                                livestream.contents
                            }<br />
                    <span style="color:#8B22F9">Date and Time</span>: ${moment(
                        data.timeStart
                    ).format("lll")}<br />
                    <br />
                </p>`;
                                }
                                SocialAPI.sendEmailNotification({
                                    message: mail,
                                    subject: "Scheduled Meeting from Ulalive",
                                    to: ls,
                                });
                            });

                            livestream.guestInvited.map((ls) => {
                                let selectedUser = _.find(
                                    users,
                                    (y) => y._id === ls
                                );
                                if (selectedUser) {
                                    let mail = "";
                                    if (
                                        selectedCategory.name === "Public Hall"
                                    ) {
                                        mail = `<p style="text-align: center; color:#000; font-size: 22px; font-weight: 600;">
                  Scheduled public hall has been set
                  </p>
                  <p style="line-height: 30px; text-align:center">
                      Hello <span style="color:#8B22F9">${
                          selectedUser.fullName
                      }</span>,<br />
                      <span style="color:#8B22F9">${
                          livestream.owner.fullName
                      }</span> has scheduled a public hall.<br/>
                      Here are the public hall details
                  </p>
                  <p style="text-align:center;background:#F1F1F1;">
                      <br />
                      <span style="color:#8B22F9">Public Hall</span>: ${
                          livestream.title
                      }<br />
                      <span style="color:#8B22F9">Description</span>: ${
                          livestream.contents
                      }<br />
                      <span style="color:#8B22F9">Date and Time</span>: ${moment(
                          data.timeStart
                      ).format("lll")}<br />
                      <br />
                  </p>`;
                                    } else if (
                                        selectedCategory.name === "Private Hall"
                                    ) {
                                        mail = `<p style="text-align: center; color:#000; font-size: 22px; font-weight: 600;">
                  Scheduled private lounge has been set
                  </p>
                  <p style="line-height: 30px; text-align:center">
                      Hello <span style="color:#8B22F9">${
                          selectedUser.fullName
                      }</span>,<br />
                      <span style="color:#8B22F9">${
                          livestream.owner.fullName
                      }</span> has scheduled a private lounge.<br/>
                      Here are the private lounge details
                  </p>
                  <p style="text-align:center;background:#F1F1F1;">
                      <br />
                      <span style="color:#8B22F9">Private Lounge</span>: ${
                          livestream.title
                      }<br />
                      <span style="color:#8B22F9">Description</span>: ${
                          livestream.contents
                      }<br />
                      <span style="color:#8B22F9">Date and Time</span>: ${moment(
                          data.timeStart
                      ).format("lll")}<br />
                      <br />
                  </p>`;
                                    } else if (
                                        selectedCategory.name === "Meeting Room"
                                    ) {
                                        mail = `<p style="text-align: center; color:#000; font-size: 22px; font-weight: 600;">
                  Scheduled meeting has been set
                  </p>
                  <p style="line-height: 30px; text-align:center">
                      Hello <span style="color:#8B22F9">${
                          selectedUser.fullName
                      }</span>,<br />
                      <span style="color:#8B22F9">${
                          livestream.owner.fullName
                      }</span> has scheduled a video meeting.<br/>
                      Here are the meeting room details
                  </p>
                  <p style="text-align:center;background:#F1F1F1;">
                      <br />
                      <span style="color:#8B22F9">Meeting Room</span>: ${
                          livestream.title
                      }<br />
                      <span style="color:#8B22F9">Description</span>: ${
                          livestream.contents
                      }<br />
                      <span style="color:#8B22F9">Date and Time</span>: ${moment(
                          data.timeStart
                      ).format("lll")}<br />
                      <br />
                  </p>`;
                                    } else if (
                                        selectedCategory.name === "VIP Circle"
                                    ) {
                                        mail = `<p style="text-align: center; color:#000; font-size: 22px; font-weight: 600;">
                  Scheduled VIP circle has been set
                  </p>
                  <p style="line-height: 30px; text-align:center">
                      Hello <span style="color:#8B22F9">${
                          selectedUser.fullName
                      }</span>,<br />
                      <span style="color:#8B22F9">${
                          livestream.owner.fullName
                      }</span> has scheduled a VIP Circle.<br/>
                      Here are the VIP Circle details
                  </p>
                  <p style="text-align:center;background:#F1F1F1;">
                      <br />
                      <span style="color:#8B22F9">VIP Circle</span>: ${
                          livestream.title
                      }<br />
                      <span style="color:#8B22F9">Description</span>: ${
                          livestream.contents
                      }<br />
                      <span style="color:#8B22F9">Date and Time</span>: ${moment(
                          data.timeStart
                      ).format("lll")}<br />
                      <br />
                  </p>`;
                                    }

                                    SocialAPI.sendEmailNotification({
                                        message: mail,
                                        subject:
                                            "Scheduled Meeting from Ulalive",
                                        to: selectedUser.email,
                                    });
                                }
                            });

                            SocialAPI.sendPushNotification({
                                userIds: [
                                    ...livestream.guestInvited,
                                    ...VIPIds,
                                ],
                                title: "Scheduled Meeting",
                                content: `<p className="notification-info">
                <span className="fullName">
                ${livestream.owner.fullName}</span> re-scheduled the livestream 
                <span className="livestream-title">${livestream.title}</span>
                to ${moment(data.timeStart).format("lll")}`,
                                type: "schedule",
                                data: {
                                    livestream: {
                                        id: livestream._id,
                                        title: livestream.title,
                                        ownerName: livestream.owner.fullName,
                                        ownerAttachment:
                                            livestream.owner.attachments,
                                        category: selectedCategory.name,
                                        scheduleTime: moment(
                                            data.timeStart
                                        ).format("lll"),
                                    },
                                    content: "livestream meeting ",
                                },
                            });

                            Swal.fire({
                                title: "Livestream",
                                text: "Livestream scheduled successfully",
                                icon: "success",
                                showCancelButton: true,
                                cancelButtonColor: "#d33",
                                showConfirmButton: false,
                                cancelButtonText: "Close",
                                customClass: {
                                    cancelButton: "order-1 right-gap",
                                    confirmButton: "order-2",
                                    denyButton: "order-3",
                                },
                            });
                        })
                        .then(() => {
                            hmsActions.leave();
                            sessionStorage.setItem(
                                "category",
                                livestream.category
                            );
                            document.location.href = "/" + userProfile.userName;
                        });
                }
            } else {
                SocialAPI.UpdatePreviewLiveStream(livestream._id, data).then(
                    () => {
                        // socket.emit("startLive", {
                        //   room: livestream._id,
                        //   infoUser: userProfile
                        // });
                    }
                );
            }

            setForm(false);
        } else {
            setForm(true);
        }
    };

    useEffect(() => {
        startSocketService();
        dispatch(searchUserRequest());
        dispatch(updateLiveStreamingRequest(true));
        dispatch(getCategoryRequest());
        dispatch(fetchEventRequest("?where=livestream:" + livestream._id));
        return () => {
            document.location.reload();
            sleep(3000);
        };
    }, []);

    useEffect(() => {
        if (roomDetail.id) {
            dispatch(
                fetchAppTokenRequest({
                    room_id: roomDetail.id,
                    user_id: userProfile._id,
                    role:
                        livestream.guestInvited.indexOf(userProfile._id) > -1
                            ? "guest"
                            : livestream.owner._id === userProfile._id
                            ? "host"
                            : "viewers",
                })
            );
        }
    }, [roomDetail]);

    useEffect(() => {
        if (livestream._id) {
            dispatch(
                createRoomRequest({
                    name: livestream._id,
                    description: livestream.contents,
                })
            );
            setTitle(livestream.title);
            setDescription(livestream.contents);
            setHashTags(
                livestream.hashtags.map((x) => {
                    return {
                        id: x,
                        text: x,
                    };
                })
            );
            if (livestream.attachments) {
                setBannerImageSrc(getImage(livestream.attachments));
            }
            handleJoin();
            dispatch(
                getProductByIDSRequest({
                    products: livestream.products.map((x) => x.id),
                })
            );

            if (socket) {
                socket.on("startLiveMessage", async () => {
                    dispatch(
                        fetchLiveStreamByIdRequest({
                            id: livestream._id,
                            history: history,
                        })
                    );
                    await new Promise((r) => setTimeout(r, 2000));
                    document.location.reload();
                });
            }

            let curUser =
                livestream.guestInvited.indexOf(userProfile._id) > -1
                    ? "guests"
                    : livestream.owner._id === userProfile._id
                    ? "host"
                    : "viewers";
            let isExistInLast = livestream.guestStats.filter(
                (x) => x.id === userProfile._id
            );
            if (isExistInLast.length > 0) {
                curUser =
                    isExistInLast[0].status === "listening" ||
                    isExistInLast[0].status === "requested"
                        ? "viewers"
                        : "guests";
            }
            if (livestream.owner._id === userProfile._id) {
                curUser = "host";
            }

            if (livestream.owner._id !== userProfile._id) {
                const interval = setInterval(() => {
                    SocialAPI.GetLiveStreamById(livestream._id).then((x) => {
                        if (
                            x.data &&
                            x.data.streamingStatus &&
                            x.data.streamingStatus.toLowerCase() === "streaming"
                        ) {
                            clearInterval(interval);
                            dispatch(
                                fetchLiveStreamByIdSuccess({ data: x.data })
                            );
                            sleep(2000);
                            history("/page/livestream");
                        } else if (
                            x.data &&
                            x.data.status &&
                            x.data.status.toLowerCase() === "inactive"
                        ) {
                            clearInterval(interval);
                            Swal.fire({
                                title: "Meeting Cancelled",
                                text: "Host cancelled the meeting.",
                                icon: "error",
                                showCancelButton: true,
                                showConfirmButton: false,
                                cancelButtonText: "Close",
                                customClass: {
                                    cancelButton: "order-1 right-gap",
                                    confirmButton: "order-2",
                                    denyButton: "order-3",
                                },
                            }).then((px) => {
                                if (px.isDismissed) {
                                    dispatch(
                                        fetchLiveStreamByIdSuccess({ data: {} })
                                    );
                                    history("/");
                                }
                            });
                        }
                    });
                }, 10000);
            }
        }
    }, [livestream]);

    useEffect(() => {
        if (userProfile._id && livestream._id && !isConnected) {
            setConnection(true);
            let actingGuest = "listening";
            let isExistInLast = livestream.guestStats.filter(
                (x) => x.id === userProfile._id
            );
            if (isExistInLast.length > 0) {
                actingGuest = isExistInLast[0].status;
            }
        }
    }, [livestream, userProfile]);

    let durationStart = [0, 0, 0];
    if (livestream.timeStart) {
        let ms = moment.utc(livestream.timeStart);
        var d = moment.duration(ms);
        durationStart = [d._data.hours, d._data.minutes, d._data.seconds];
    }

    const handleJoin = () => {
        if (socket) {
            let actingGuest = true;
            let isExistInLast =
                livestream.guestStats &&
                livestream.guestStats.filter((x) => x.id === userProfile._id);
            if (isExistInLast && isExistInLast.length > 0) {
                actingGuest = isExistInLast[0].status === "joined";
            }
            if (livestream.guestInvited) {
                socket.emit("joinLive", {
                    room: livestream._id,
                    type:
                        livestream.guestInvited.indexOf(userProfile._id) > -1 &&
                        actingGuest
                            ? "guests"
                            : livestream.owner._id === userProfile._id
                            ? "host"
                            : "viewers",
                    infoUser: userProfile,
                });
            }
        }
    };

    if (!livestream._id) {
        return <p />;
    }

    let currentRole =
        livestream.guestInvited &&
        livestream.guestInvited.indexOf(userProfile._id) > -1
            ? "guest"
            : livestream.owner._id === userProfile._id
            ? "host"
            : "audience";
    let isExistInLast =
        livestream.guestStats &&
        livestream.guestStats.filter((x) => x.id === userProfile._id);
    if (isExistInLast.length > 0) {
        currentRole =
            isExistInLast[0].status === "listening" ||
            isExistInLast[0].status === "requested"
                ? "audience"
                : isExistInLast[0].status === "joined"
                ? "guest"
                : currentRole;
    }

    if (livestream.owner._id === userProfile._id) {
        currentRole = "host";
    }

    const shareUrl =
        process.env.REACT_APP_URL + "/video/" + livestream._id;
    let clasName = bannerImageSrc ? "lvproductimage" : "img-thumbnail";
    const currentStatus = livestream.guestStats.filter(
        (x) => x.id === userProfile._id
    );
    let curStatus = "listening";
    if (currentStatus.length > 0) {
        curStatus = currentStatus[0].status;
    }

    sessionStorage.setItem("guestStats", livestream.guestStats);

    const onJoin = () => {
        if (
            livestream.timeStart &&
            moment(livestream.timeStart).unix() > moment().unix()
        ) {
            Swal.fire({
                title: "<strong>Meeting scheduled</strong>",
                icon: "info",
                customClass: {
                    cancelButton: "order-1 right-gap",
                    confirmButton: "order-2",
                    denyButton: "order-3",
                },
                html: `<div class="alert" role="alert">
           <h4 className="text-center">Your meeting has been scheduled at <br/> <i class="text-info">${moment(
               livestream.timeStart
           ).format("lll")}</i></h4>
         </div>`,
                showCancelButton: true,
                showConfirmButton: true,
                cancelButtonText: "Close",
                confirmButtonText: "Force start",
            }).then((res) => {
                if (res.isConfirmed) {
                    if (socket) {
                        savePreviewStream();
                    }
                    if (livestream.streamingStatus === "Waiting") {
                        dispatch(
                            createWowzaEventRequest({
                                streamKey: livestream.code,
                                eventType: "Start-Live",
                                data: {},
                                id: livestream._id,
                                history: history,
                            })
                        );
                    }
                }
            });
        } else if (
            livestream.timeStart &&
            moment(livestream.timeStart).diff(moment(), "minutes") < 15
        ) {
            Swal.fire({
                title: "<strong>Scheduled meeting</strong>",
                icon: "info",
                customClass: {
                    cancelButton: "order-1 right-gap",
                    confirmButton: "order-2",
                    denyButton: "order-3",
                },
                html: `<div class="alert" role="alert">
           <h4 className="text-center"> Meeting has been expired at <br/> <i class="text-danger">${moment(
               livestream.timeStart
           ).format("lll")}</i></h4>
         </div>`,
                showCancelButton: true,
                showConfirmButton: true,
                cancelButtonText: "Close",
                confirmButtonText: "Force start now",
            }).then((res) => {
                if (res.isConfirmed) {
                    if (socket) {
                        savePreviewStream();
                    }
                    if (livestream.streamingStatus === "Waiting") {
                        dispatch(
                            createWowzaEventRequest({
                                streamKey: livestream.code,
                                eventType: "Start-Live",
                                data: {},
                                id: livestream._id,
                                history: history,
                            })
                        );
                    }
                }
            });
        } else {
            if (socket) {
                savePreviewStream();
            }
            if (livestream.streamingStatus === "Waiting") {
                dispatch(
                    createWowzaEventRequest({
                        streamKey: livestream.code,
                        eventType: "Start-Live",
                        data: {},
                        id: livestream._id,
                        history: history,
                    })
                );
            }
        }
    };

    function handleDelete(i) {
        const tags = hashTags.filter((tag, index) => index !== i);
        setHashTags(tags);
    }

    function handleAddition(tag) {
        if (!IsNullOrEmpty(tag.id) && hashTags.length < 5) {
            setHashTags([...hashTags, tag]);
        }
    }

    function handleDrag(tag, currPos, newPos) {
        const tags = hashTags;
        const newTags = tags.slice();

        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);

        // re-render
        setHashTags(newTags);
    }

    var timeZones = moment.tz.names();

    const sendRemainder = () => {
        const mail = `    <p style="text-align: center;
      background: #8B22F9;
      color: white;
      font-weight: bold;
      line-height: 28px;
      font-size: 20px;
      padding: 12px;">
          Reminder: Your meeting has start
      </p>
      <p style="border:1px dashed"></p>
      <p style="line-height: 30px;text-align: center;">
          Hi ${
              livestream.owner.fullName
          }, here is a reminder for you to start our meeting
          <br />
          The meeting is scheduled as below
      </p>
      <div style="background: #f5f6fa;padding: 10px">
          <p style="line-height: 12px;text-align: center;"><span style="color:#8B22F9">Title:</span> ${
              livestream.title
          }</p>
          <p style="line-height: 12px;text-align: center;"><span style="color:#8B22F9">Date and Time:</span>${moment(
              livestream.timeStart
          ).format("lll")}</p>
      </div>
      <p style="text-align: center;padding: 16px;">
          <a href="https://app.ulalive.com/video/${
              livestream._id
          }" style="background: #8B22F9;
              color: white;
              padding: 16px;
              text-decoration: none;
              border-radius: 16px;
              font-weight: bold;">
              Start meeting
          </a>
      </p>`;

        SocialAPI.sendEmailNotification({
            message: mail,
            subject: "Livestream reminder from Ulalive",
            to: livestream.owner.email,
        }).then(() => {
            toastr.success("Reminder sent successfully.");
        });
    };

    let Routes = [{ id: 1, route: "info", path: "/page/preview/info" }];

    if (cartProducts.length > 0) {
        Routes.push({ id: 2, route: "product", path: "/page/preview/product" });
    }

    Routes.push({ id: 3, route: "Audience", path: "/page/preview/audience" });

    if (livestream.owner._id === userProfile._id) {
        Routes.push({
            id: 4,
            route: "Schedule",
            path: "/page/preview/schedule",
        });
    }

    return (
        <div className="px-2 sm:px-4 py-7 lg:p-0 lg:h-full lg:overflow-hidden">
            <div className="flex flex-col lg:flex-row ">
                <div className="flex-1 h-full rounded-lg border border-black-10 lg:mx-8 mb-4 lg:my-7">
                    <div className="w-full ">
                        {!IsNullOrEmpty(token) ? (
                            <Preview
                                userProfile={userProfile}
                                initialName={""}
                                skipPreview={false}
                                livestream={livestream}
                                env={process.env.REACT_APP_ENV}
                                onJoin={() => onJoin()}
                                token={token}
                                onChangeFullScreen={(v) => setFullScreen(v)}
                            />
                        ) : (
                            <></>
                        )}
                    </div>
                </div>
                <div className="w-full lg:w-[345px] bg-white m lg:h-full lg:overflow-hidden">
                    <div className="p-4 bg-white w-full">
                        <div className="mb-5">
                            <ul className="flex items-center space-x-5 pb-[7px] border-b border-black-10">
                                {Routes.map((route) => {
                                    return (
                                        <li key={route.id}>
                                            <NavLink
                                                to={`${route.path}`}
                                                className="text-sm font-medium text-black-60 hover:text-orange-color pb-[7px] hover:border-b-2 border-orange-color capitalize replay-chat-nav"
                                            >
                                                {route.route}
                                            </NavLink>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>

                        <div className="">
                            <Outlet />
                        </div>
                    </div>
                </div>
            </div>
            <Modal show={shareModal} onClose={() => setShareModal(false)}>
                <SharePop
                    onClose={() => setShareModal(false)}
                    shareUrl={shareUrl}
                    title={livestream.owner.fullName}
                    subTitle={"@" + livestream.owner.userName}
                    image={getImage(livestream.owner.attachments)}
                    heading="Share"
                />
            </Modal>
        </div>
    );
};

export default PreviewLive;
